import {memo} from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import moment from 'moment/moment';
import {
  availableOptions,
  getEdReviewSessionDetails, isCreatingSlot,
  selectedDate as currentSelectedDate,
} from '../../../../../../../../../store/reducers/reviews';
import {
  calculateEventHeight,
  calculateEventLeft,
  calculateEventTop,
} from '../../../../../utils/edReviewUtils';
import {COLUMN_GAP, OFFSET, SLOT_HEIGHT} from '../edReviewCalendarDaily';
import TemporarySelectedSlot from './temporarySelectedSlot';
import {calculateTileHeight} from '../../../utils/sessionUtilities';

const AvailableLockSlots = ({ colWidth, findEventIndex }) => {
  const dispatch = useDispatch();

  const options = useSelector(availableOptions);
  const date = useSelector(currentSelectedDate);

  if (options) {
    return Object.keys(options).map(
      (sessionId) => {
        const session = dispatch(getEdReviewSessionDetails({sessionId}));

        return !isEmpty(options?.[sessionId]) &&
        options?.[sessionId].map((availableHour, hrIndex) => {
          const [hours, minutes] = availableHour.split(':');
          const eventHour = moment(date, 'DD/MM/YYYY')
            .set({hour: hours, minute: minutes})
            .toISOString();
          const availableEvent = {
            sessionId,
            startDate: eventHour,
            endDate: moment(eventHour).add(session?.fixedSlotDuration && session?.slotDurationInMinutes ? session?.slotDurationInMinutes : 30, 'minutes').toISOString(),
          };

          return (
            <TemporarySelectedSlot
              session
              availableSlot
              id={availableHour}
              colWidth={colWidth}
              event={availableEvent}
              key={`${sessionId}${hrIndex}`}
              options={{
                top: calculateEventTop({
                  isReview: false,
                  offset: OFFSET,
                  event: availableEvent,
                  slotHeight: SLOT_HEIGHT,
                }),
                left: calculateEventLeft({
                  columnIndex: findEventIndex(sessionId),
                  offset: OFFSET,
                  eventSlotWidth: colWidth,
                  columnGap: COLUMN_GAP,
                }),
                height: calculateTileHeight(session),
                width: colWidth,
              }}
            />
          );
        });
      }
    )} else {
    return null
  }
};

export const NewAvailableLockSlots = ({ colWidth, columnIndex, onSelectTime }) => {
  const options = useSelector(availableOptions);
  const isCreating = useSelector(isCreatingSlot);

  if (!isEmpty(options?.[columnIndex]?.events) && isCreating) {
    // console.log("options?.[columnIndex].events:", options?.[columnIndex].events);
    return options?.[columnIndex].events.map((ev, evIdx) => {
      return (
        <TemporarySelectedSlot
          session
          id={evIdx}
          event={ev}
          key={evIdx}
          availableSlot
          colWidth={colWidth}
          columnIndex={columnIndex}
          onSelectTime={onSelectTime}
          options={{
            top: calculateEventTop({
              isReview: false,
              offset: OFFSET,
              event: ev,
              slotHeight: SLOT_HEIGHT,
            }),
            left: 0,
            height: calculateEventHeight({
              event: ev,
              offset: OFFSET,
              isReview: false,
              eventSlotHeight: SLOT_HEIGHT,
            }),
            width: colWidth,
            zIndex: 999
          }}
        />
      );
    })
    } else {
    return null
  }
};

AvailableLockSlots.propTypes = {
  colWidth: PropTypes.string,
  findEventIndex: PropTypes.func,
  sessionColumns: PropTypes.object,
}

NewAvailableLockSlots.propTypes = {
  colWidth: PropTypes.string,
  findEventIndex: PropTypes.func,
  sessionColumns: PropTypes.object,
}

export default memo(AvailableLockSlots, _isEqual);